import { render, staticRenderFns } from "./ServiceType.vue?vue&type=template&id=4f4b074a&scoped=true"
import script from "./ServiceType.vue?vue&type=script&lang=js"
export * from "./ServiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b074a",
  null
  
)

export default component.exports